module.exports = __webpack_public_path__ + "static/1_1_example-1-675a5e016538471776a9addf3690b44f.svg";